import { apiService } from './api.service'

export interface UploadProgress {
  loaded: number
  total: number
  percentage: number
}

class UploadService {
  async uploadDocument(
    file: File,
    options?: {
      title?: string
      correspondent?: number
      document_type?: number
      storage_path?: number
      tags?: number[]
      created_date?: string
    },
    onProgress?: (progress: UploadProgress) => void
  ): Promise<void> {
    const formData = new FormData()
    formData.append('document', file, file.name)
    formData.append('from_webui', 'true')

    if (options?.title) formData.append('title', options.title)
    if (options?.correspondent) formData.append('correspondent', String(options.correspondent))
    if (options?.document_type) formData.append('document_type', String(options.document_type))
    if (options?.storage_path) formData.append('storage_path', String(options.storage_path))
    if (options?.created_date) formData.append('created', options.created_date)
    if (options?.tags) {
      options.tags.forEach((tag) => formData.append('tags', String(tag)))
    }

    await apiService.post('documents/post_document/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          const percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          onProgress({
            loaded: progressEvent.loaded,
            total: progressEvent.total,
            percentage,
          })
        }
      },
    })
  }

  async createDocumentMetadata(options: {
    title?: string
    correspondent?: number | null
    document_type: number
    storage_path?: number | null
    tags?: number[]
    custom_fields?: Record<number, any>
    template_id?: number | null
    created_date?: string
  }): Promise<{ document_id?: number; task_id?: string }> {
    const formData = new FormData()
    formData.append('metadata_only', 'true')
    formData.append('from_webui', 'true')
    formData.append('document_type', String(options.document_type))
    if (options.template_id) formData.append('template_id', String(options.template_id))

    if (options.title) formData.append('title', options.title)
    if (options.correspondent) formData.append('correspondent', String(options.correspondent))
    if (options.storage_path) formData.append('storage_path', String(options.storage_path))
    if (options.created_date) formData.append('created', options.created_date)
    if (options.tags && options.tags.length > 0) {
      options.tags.forEach((tag) => formData.append('tags', String(tag)))
    }
    if (options.custom_fields && Object.keys(options.custom_fields).length > 0) {
      formData.append('custom_fields', JSON.stringify(options.custom_fields))
    }

    const response = await apiService.post<{ document_id?: number; task_id?: string }>('documents/post_document/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  }
}

export const uploadService = new UploadService()
